import React from 'react';
import { useTranslation } from 'react-i18next';
import s from '../DashboardDrawer.module.scss';
const PanelSummary = ({ panels }) => {
    const { i18n, t } = useTranslation();
    return (React.createElement(React.Fragment, null, panels.map(({ title, value }) => (React.createElement("td", { key: title, className: s['box__summary--item-value'], dir: i18n.dir() }, value === undefined ? t('noData') : value)))));
};
export default PanelSummary;
